import { useMediaQuery, useTheme } from '@material-ui/core'
import { Cancel } from '@material-ui/icons'
import React from 'react'
import {
  Create,
  CreateProps,
  useTranslate,
  SimpleForm,
  TextInput,
  Toolbar,
  ToolbarProps,
  SaveButton,
  ListButton,
  SelectInput,
} from 'react-admin'
import { useHasAuthority } from '../../../hooks/useHasAuthority'
import { Authority } from '../../../../core/auth/Authority'
import FilteredReferenceInput from '../../../common/FilteredReferenceInput'
import { ResourceName } from '../../../../core/ResourceName'
import { MediaContentTypes } from '../../../../core/enum/MediaContentTypes'
import { EngineMediaFileDto } from '../../../../core/dto/engine-media/engine-media-file.dto'

const validateEngineMediaFileCreate = (values: EngineMediaFileDto) => {
  const errors: { [n: string]: string } = {}
  if (!values.engineMediaActionId) {
    errors.engineMediaActionId = 'ra.validation.required'
  }
  if (!values.mediaContentType) {
    errors.mediaContentType = 'ra.validation.required'
  }
  if (!values.filePathId) {
    errors.filePathId = 'ra.validation.required'
  }
  return errors
}

const CreateTitle = () => {
  const translate = useTranslate()
  return <span>{translate('resources.engine-media-files.titles.create')}</span>
}

const CreateToolbar = (props: ToolbarProps) => (
  <Toolbar {...props}>
    <SaveButton />
    <ListButton icon={<Cancel />} label="const.cancel" />
  </Toolbar>
)

export const EngineMediaFileCreate = (props: CreateProps) => {
  const hasAuthority = useHasAuthority()
  const theme = useTheme()
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Create {...props} hasShow={false} title={<CreateTitle />}>
      <SimpleForm
        redirect="show"
        toolbar={<CreateToolbar />}
        validate={validateEngineMediaFileCreate}
      >
        <TextInput source="description" />
        {hasAuthority(Authority.VIEW_ENGINE_MEDIA_ACTIONS) && (
          <FilteredReferenceInput
            source="engineMediaActionId"
            reference={ResourceName.ENGINE_MEDIA_ACTIONS}
            sort={{ field: 'name', order: 'ASC' }}
            perPage={smallScreen ? 5 : 15}
            filterSource="name"
            selectWithPaginationInputProps={{
              optionText: 'name',
              showFilter: true,
            }}
          />
        )}
        {hasAuthority(Authority.VIEW_FILES) && (
          <FilteredReferenceInput
            source="filePathId"
            reference={ResourceName.FILES}
            sort={{ field: 'name', order: 'ASC' }}
            perPage={smallScreen ? 5 : 15}
            filterSource="name"
            selectWithPaginationInputProps={{
              optionText: 'name',
              showFilter: true,
            }}
            filter={{
              fileExtension: '.jpg,.png,.jpeg,.avi',
            }}
          />
        )}
        <SelectInput
          source="mediaContentType"
          choices={Object.entries(MediaContentTypes).map(([value]) => ({
            id: value,
            name: `resources.enums.MediaContentTypes.${value}`,
          }))}
        />
      </SimpleForm>
    </Create>
  )
}
